export default {
    methods: {
        getNewCondition: function () {
            return {
                testValue: 0,
                frecuentCustomerExclusion: 1,
                startTime: null,
                endTime: null,
                rewardGrant: 0,
                checkType: 1,
                days: [false, false, false, false, false, false, false],
                hostValue: false,
                bits: [
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false
                ],
                type: null,
                useNetPrice: false,
                couponValidity: 1,
                maxQtyPerItem: 0,
                logicOperator: 0,
                itemElegibility: true,
                paymentTypes: [],
                promotionVariable: null,
                promotionVariableValue: null,
                customerProfiles: [],
                editableControls: [],
                originCondition: null,
                useValueAsPromoVar: false,
                unitPriceFrom: null,
                unitPriceTo: null,
                compositePaymentTypes: null,
                finantialPlanFrom: null,
                finantialPlanTo: null,
                negotiation: null,
                breakPoints: [],
                includedItems: [],
                excludedItems: [],
                includedIntersections: [],
                excludedIntersections: [],
                includedManufacturers: [],
                excludedManufacturers: [],
                includedMixmatches: [],
                excludedMixmatches: [],
                includedDepartments: [],
                excludedDepartments: []
              };
        },
        getNewReward : function() {
            return {
                rewardType: null,
                limitType: null,
                logicOperator: 0,
                updateCustomerInfo: true,
                sortOrder: 0,
                // sponsorPanel
                value: null,
                sponsor: 1,
                sellAtPriceAsPack: false,
                // paymentInstrumentRewardPanel
                paymentTypes: [],
                promotionVariableValue: null,
                promotionVariable: null,
                finantialPlanTo: null,
                finantialPlanFrom: null,
                // limitPanel
                limitPromotionVariable: null,
                limitSpanType: 1,
                limitQuantity: 0,
                // clientLevelPanel
                frecuentCustomerCondition: 1,
                level: 1,
                customerProfiles: [],
                repeatOnBreakPoint: 0,
                // miscellaneousPanel
                couponNumber: "",
                promoteTransactionLevel: 0,
                decrementMinOrder: 0,
                distributeRewardValue: 0,
                //Ejecutar beneficio
                limitExceedItemValue: 0,
                itemsQuantityToExecute: 1,
                itemsQuantityToBenefit: 1,
                //Include and excluded
                includedItems: [],
                excludedItems: [],
                includedIntersections: [],
                excludedIntersections: [],
                includedManufacturers: [],
                excludedManufacturers: [],
                includedMixmatches: [],
                excludedMixmatches: [],
                includedDepartments: [],
                excludedDepartments: [],
                editableControls: []
            }
        }
    }
};
